<template>
    <b-tab title="Meus dados" active>
        <template>
            <b-form-group
                id="username_group_id"
                label="Nome de usuário"
                label-for="username_id"
            >
                <b-form-input
                    id="username_id"
                    :value="username"
                    :disabled="true"
                    placeholder="Nome de usuário..."
                ></b-form-input>
            </b-form-group>
            <b-form-group
                v-if="changePassword"
                id="old_password_group_id"
                label="Senha atual"
                label-for="old_password_id"
                :state="errors.old_password.state"
                :invalid-feedback="errors.old_password.message"
                description="Digite a senha atual."
            >
                <b-form-input
                    id="old_password_id"
                    v-model="data.old_password"
                    type="password"
                    placeholder="Senha atual..."
                    :state="errors.old_password.state"
                    :disabled="loading"
                    @change="errors.old_password.state = null"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                v-if="changePassword"
                id="password1_group_id"
                label="Nova senha"
                label-for="password1_id"
                :state="errors.password1.state"
                :invalid-feedback="errors.password1.message"
            >
                <template v-slot:description>
                    <p
                        v-for="(tip, index) in passwordTips"
                        :key="index"
                        class="text-secondary mb-0"
                    >
                        {{ tip }}
                    </p>
                </template>
                <b-form-input
                    id="password1_id"
                    v-model="data.password1"
                    type="password"
                    :state="errors.password1.state"
                    required
                    placeholder="Nova senha..."
                    :disabled="loading"
                    @change="errors.password1.state = null"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                v-if="changePassword"
                id="password2_group_id"
                label="Senha (novamente)"
                label-for="password2_id"
                :state="errors.password2.state"
                :invalid-feedback="errors.password2.message"
                description="Digite a mesma senha informada anteriormente, para verificação."
            >
                <b-form-input
                    id="password2_id"
                    v-model="data.password2"
                    type="password"
                    placeholder="Senha..."
                    :state="errors.password2.state"
                    :disabled="loading"
                    @change="errors.password2.state = null"
                ></b-form-input>
            </b-form-group>
            <b-form-group>
                <b-button
                    size="sm"
                    variant="link"
                    :disabled="loading"
                    :class="`text-decoration-none${
                        changePassword ? ' text-danger' : ''
                    }`"
                    @click="changePasswordStatus"
                >
                    {{
                        changePassword
                            ? "Cancelar alteração de senha"
                            : "Alterar senha"
                    }}
                </b-button>
            </b-form-group>
            <b-form-group
                id="email_group_id"
                label="E-mail"
                label-for="email_id"
                :state="errors.email.state"
                :invalid-feedback="errors.email.message"
            >
                <b-form-input
                    id="email_id"
                    v-model="data.email"
                    type="email"
                    placeholder="E-mail..."
                    :disabled="loading"
                    :state="errors.email.state"
                    @change="errors.email.state = null"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="first_name_group_id"
                label="Nome"
                label-for="first_name_id"
                :state="errors.first_name.state"
                :invalid-feedback="errors.first_name.message"
            >
                <b-form-input
                    id="first_name_id"
                    v-model="data.first_name"
                    :disabled="loading"
                    placeholder="Nome..."
                    :state="errors.first_name.state"
                    @change="errors.first_name.state = null"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="last_name_group_id"
                label="Sobrenome"
                label-for="last_name_id"
                :state="errors.last_name.state"
                :invalid-feedback="errors.last_name.message"
            >
                <b-form-input
                    id="last_name_id"
                    v-model="data.last_name"
                    :disabled="loading"
                    placeholder="Sobrenome..."
                    :state="errors.last_name.state"
                    @change="errors.last_name.state = null"
                ></b-form-input>
            </b-form-group>

            <div class="text-right">
                <b-button
                    variant="secondary"
                    :disabled="loading"
                    @click="confirm"
                    >{{ loading ? "Salvando, aguarde..." : "Salvar" }}</b-button
                >
            </div>
        </template>
    </b-tab>
</template>

<script>
import { mapActions } from "vuex";
import hasProperty from "@/utils/hasProperty";
import sleep from "@/utils/sleep";

export default {
    name: "UserTab",
    data() {
        return {
            data: {},
            changePassword: false,
            errors: {},
            loading: false,
            passwordTips: [
                "A senha não pode ser muito parecida com o resto das suas informações pessoais.",
                "A senha precisa conter pelo menos 8 caracteres.",
                "A senha não pode ser uma senha comumente utilizada.",
                "A senha não pode ser inteiramente numérica.",
                "A senha não pode ser igual a senha atual."
            ]
        };
    },
    computed: {
        username() {
            return this.$store.state.auth.user.username;
        }
    },
    beforeMount() {
        let { first_name, last_name, email } = this.$store.state.auth.user;
        this.changePassword = false;
        this.data = {
            first_name,
            last_name,
            email,
            old_password: "",
            password1: "",
            password2: ""
        };
        this.errors = this.buildErrors();
    },
    methods: {
        ...mapActions("auth", ["updateUser"]),
        buildErrors(errors = {}) {
            const data = {};

            for (const key of Object.keys(this.data)) {
                data[key] = {
                    state: null,
                    message: ""
                };
            }

            for (const [field, messages] of Object.entries(errors)) {
                data[field] = {
                    state: false,
                    message: messages[0]
                };
            }

            if (hasProperty(errors, "password")) {
                data.password2.state = false;
                data.password2.message = errors.password[0];
            }

            if (hasProperty(errors, "old_password")) {
                data.old_password.state = false;
                data.old_password.message = errors.old_password[0];
            }

            return data;
        },
        validate() {
            const {
                first_name,
                last_name,
                email,
                old_password,
                password1,
                password2
            } = this.data;

            const result = {
                data: {
                    first_name,
                    last_name,
                    email
                },
                isValid: true
            };

            if (this.changePassword) {
                if (old_password.trim() === "") {
                    this.errors.old_password.state = false;
                    this.errors.old_password.message =
                        "Este campo não pode ser em branco.";
                    result.isValid = false;
                }

                if (password1 !== password2) {
                    this.errors.password2.state = false;
                    this.errors.password2.message =
                        "As senhas informadas não conferem.";
                    this.errors.password1.state = false;
                    this.errors.password1.message =
                        "As senhas informadas não conferem.";
                    result.isValid = false;
                }

                if (old_password === password1) {
                    this.errors.password1.state = false;
                    this.errors.password1.message =
                        "A nova senha não pode ser igual a senha atual.";
                    result.isValid = false;
                }

                if (result.isValid) {
                    result.data.password = password1;
                    result.data.old_password = old_password;
                }
            }

            return result;
        },
        async confirm(event) {
            event.preventDefault();

            const { data, isValid } = this.validate();

            if (isValid) {
                this.loading = true;
                await sleep(1000);

                try {
                    await this.updateUser(data);
                    this.$bvToast.toast(
                        `Usuário ${this.username} atualizado com sucesso.`,
                        {
                            title: "Aviso",
                            variant: "info",
                            noCloseButton: true
                        }
                    );
                } catch ({ response }) {
                    if (response.status === 400) {
                        this.errors = this.buildErrors(response.data);
                    } else {
                        this.$bvToast.toast(
                            "Erro ao executar operação, tente novamente mais tarde ou informe ao administrador do sistema.",
                            {
                                title: "Aviso",
                                variant: "danger",
                                noCloseButton: true
                            }
                        );
                    }
                } finally {
                    this.loading = false;
                }
            }
        },
        changePasswordStatus() {
            this.changePassword = !this.changePassword;
            this.data.old_password = "";
            this.data.password1 = "";
            this.data.password2 = "";
            this.errors.password1.state = null;
            this.errors.password2.state = null;
            this.errors.old_password.state = null;
        }
    }
};
</script>
